import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row, Col } from "reactstrap";

import getQueryString from "../../helpers/getQueryString";
import userActions from "../../actions/userActions";

const ConfirmEmailForm = () => {
  const query = getQueryString();
  const dispatch = useDispatch();

  const [state, setState] = useState({
    email: query.get("email"),
    token: query.get("token"),
  });

  useEffect(() => {
    if (state.email === "") {
      const tempState = {
        email: query.get("email"),
        token: query.get("token"),
      };
      setState({ ...tempState }, () => {
        dispatch(userActions.confirmEmail(state));
      });
    } else {
      dispatch(userActions.confirmEmail(state));
    }
  }, [dispatch, state, query]);

  return (
    <Row className="pr-0 pl-0 psInfo">
      <Col>
        <h2 className="text-center text-uppercase">Email confirmation</h2>
        <hr />
        <Row className="padTop">
          <Col md={6}>
            <h4 className="text-uppercase">Email confirmed</h4>
            <Row>
              <Col>
                <span>
                  Thank you for confirming your email. Your are being redirected
                  to the login page.
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ConfirmEmailForm;
